<template>
    <div class="a">
        <top></top>
        <el-carousel :interval="5000" arrow="always">
            <el-carousel-item v-for="(item, index) in images" :key="index">
                <img :src="item.image1" @click="goimage(item.brief_info)" alt="" width="100%">
            </el-carousel-item>
        </el-carousel>
        <div class="notice">
            <div class="notice_center">
                <img src="../image/gonggao.png" alt="" width="17px" height="15px">
                <div class="information">
                    <!-- <div class="dibu2">
                        <span id="marquee1">{{ message }}{{ message }}</span>
                        <span id="marquee2">{{ message }}{{ message }}</span>
                    </div> -->
                    <div class="notice_con">
                        <Slider :sliderData="sliderData" @getTitle="getSliderTitle" />
                    </div>
                </div>
            </div>
        </div>
        <div class="four">
            <div class="wl">
                <div>
                    <img src="../image/wl.png"
                        style="width: 100%;position: absolute;z-index: 888;left: 0;top: 0;height: 300px;" alt="">
                    <!-- <div
                        style="position: absolute;width: 100%;height: 300px;display: flex;align-items: center;justify-content: center;top:0;flex-direction: column;z-index: 888;position: absolute;left: 0;">
                        <h1>齐来崇拜</h1>
                        <p>Encounter&nbsp;Jesus</p>
                    </div> -->
                    <div class="wlcba">
                        <div class="wlcb_top" @click="wl">
                            <div class="wl_left">
                                <!-- <p style="font-size: 25px;">齐来崇拜</p>
                                <p>Encounter Jesus</p> -->
                            </div>
                            <div class="wl_right">
                                <!-- <img src="../image/right.png" alt="" style="width: 25px;height: 25px"> -->
                            </div>
                        </div>
                        <div class="wlcb_bottom" style="display: flex;flex-direction: column">
                            <div class="bh" @click="zb" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="time" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="download" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="wlcb">
                <div class="wlcb_top" @click="wl">
                    <div class="wl_left">
                        <p style="font-size: 25px;">齐来崇拜</p>
                        <p>Encounter Jesus</p>
                    </div>
                    <div class="wl_right">
                        <img src="../image/right.png" alt="" style="width: 25px;height: 25px">
                    </div>
                </div>
                <div class="wlcb_bottom">
                    <el-radio-group v-model="radio" style="display: flex;flex-direction: column">
                        <el-radio :label="3" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">直播入口</el-radio>

                        <el-radio :label="6"style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">聚会时间</el-radio>
                        <el-radio :label="9" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">APP下载</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="xy">
                <div>
                    <img src="../image/xy.png" alt=""
                        style="width: 100%;position: absolute;z-index: 888;left: 0;top: 0;height: 300px;">
                    <!-- <div
                        style="position: absolute;z-index: 888;width: 100%;height: 300px;display: flex;align-items: center;justify-content: center;top:0;flex-direction: column;">
                        <h1>信仰之门</h1>
                        <p>To&nbsp;our&nbsp;Faith</p>
                    </div> -->
                    <div class="xyzma">
                        <div class="xyzm_top" @click="xy">
                            <div class="xy_left">
                                <!-- <p style="font-size: 25px;">信仰之门</p>
                                <p>To&nbsp;our&nbsp;Faith</p> -->
                            </div>
                            <div class="xy_right">
                                <!-- <img src="../image/right.png" alt="" style="width: 25px;height: 25px"> -->
                            </div>
                        </div>
                        <div class="xyzm_bottom" style="display: flex;flex-direction: column">
                            <div class="bh" @click="xyjj" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="jtjj" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="mejz" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="sjxs" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="xyzm">
                <div class="xyzm_top" @click="xy">
                    <div class="xy_left">
                        <p style="font-size: 25px;">信仰之门</p>
                        <p>To&nbsp;our&nbsp;Faith</p>
                    </div>
                    <div class="xy_right">
                        <img src="../image/right.png" alt="" style="width: 25px;height: 25px">
                    </div>
                </div>
                <div class="xyzm_bottom">
                    <el-radio-group v-model="radios" style="display: flex;flex-direction: column">
                        <el-radio :label="4" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">福音信息</el-radio>
                        <el-radio :label="5" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">生命之道</el-radio>
                        <el-radio :label="6" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">圣诗赞美</el-radio>
                        <el-radio :label="7" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">圣剧欣赏</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="sm">
                <div>
                    <img src="../image/sm.png" alt=""
                        style="width: 100%;position: absolute;z-index: 888;left: 0;top: 0;height: 300px;">
                    <!-- <div
                        style="position: absolute;z-index: 888;width: 100%;height: 300px;display: flex;align-items: center;justify-content: center;top:0;flex-direction: column;">
                        <h1>生命之粮</h1>
                        <p>Bread&nbsp;of&nbsp;Life</p>
                    </div> -->
                    <div class="smzla">
                        <div class="smzl_top" @click="sm">
                            <div class="xy_left">
                                <!-- <p style="font-size: 25px;">生命之粮</p>
                        <p>To&nbsp;our&nbsp;Faith</p> -->
                            </div>
                            <div class="xy_right">
                                <!-- <img src="../image/right.png" alt="" style="width: 25px;height: 25px"> -->
                            </div>
                        </div>
                        <div class="smzl_bottom" style="display: flex;flex-direction: column">
                            <div class="bh" @click="zdzt" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="zmzt" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="jzzt" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                            <div class="bh" @click="zlxz" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="smzl">
                <div class="smzl_top" @click="sm">
                    <div class="xy_left">
                        <p style="font-size: 25px;">生命之粮</p>
                        <p>Bread of Life</p>
                    </div>
                    <div class="xy_right">
                        <img src="../image/right.png" alt="" style="width: 25px;height: 25px">
                    </div>
                </div>
                <div class="smzl_bottom">
                    <el-radio-group v-model="radioa" style="display: flex;flex-direction: column">
                        <el-radio :label="8" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">日常证道</el-radio>
                        <el-radio :label="9" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">专题证道</el-radio>
                        <el-radio :label="10" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">查经系列</el-radio>
                        <el-radio :label="11" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">资料下载</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="tq" >
                <div>
                    <img src="../image/tq.png" alt=""
                        style="width: 100%;position: absolute;z-index: 888;left: 0;top: 0;height: 300px;">
                    <!-- <div
                        style="position: absolute;z-index: 888;width: 100%;height: 300px;display: flex;align-items: center;justify-content: center;top:0;flex-direction: column;">
                        <h1>团契之家</h1>
                        <p>House&nbsp;of&nbsp;Fellowships</p>
                    </div> -->
                    <div class="tqzja">
                        <div class="tqzj_top" @click="tq">
                            <div class="tq_left">
                                <!-- <p style="font-size: 25px;">团契之家</p>
                                <p>To&nbsp;our&nbsp;Faith</p> -->
                            </div>
                            <div class="tq_right">
                                <!-- <img src="../image/right.png" alt="" style="width: 25px;height: 25px"> -->
                            </div>
                        </div>
                        <div class="tqzj_bottom">
                            <el-radio-group v-model="radiob" style="display: flex;flex-direction: column">
                                <div class="bh" @click="tqjj" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>
                                <div class="bh" @click="sgjj" style="width: 200px;height: 30px;display: flex;align-items: center;"></div>

                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tqzj">
                <div class="tqzj_top" @click="tq">
                    <div class="tq_left">
                        <p style="font-size: 25px;">团契之家</p>
                        <p>House of Fellowships</p>
                    </div>
                    <div class="tq_right">
                        <img src="../image/right.png" alt="" style="width: 25px;height: 25px">
                    </div>
                </div>
                <div class="tqzj_bottom">
                    <el-radio-group v-model="radiob" style="display: flex;flex-direction: column">
                        <el-radio :label="8" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">事工团契</el-radio>
                        <el-radio :label="9" style="width: 200px;height: 30px;display: flex;align-items: center;padding-left: 5px;">生命见证</el-radio>

                    </el-radio-group>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>

import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import { readyz, slides, notics } from "../api/index"
import Slider from "../components/Slider.vue";
export default {
    components: {
        top,
        bottom,
        Slider
    },
    data() {
        return {
            message: '今天天气好晴朗,处处好风光!今天天气好晴朗,处处好风光!今天天气好晴朗,处处好风光!今天天气好晴朗,处处好风光!',
            marqueeVar: null,
            speed1: 0,
            speed2: 0,
            images: [],
            radio: 1,
            radios: 1,
            radioa: 1,
            radiob: 1,
            sliderData: []
        }
    },
    created() {
        // setTimeout(() => {
        //     this.runMarquee()
        // }, 1000)
        readyz().then(res => {
            console.log(res)
        })
        slides().then(res => {

            this.images = res.data.data
        })
        notics().then(res => {
            console.log(res)
            this.sliderData = res.data.data
        })
    },
    methods: {
        goimage(item){
            window.open(item)

        },
        getSliderTitle(title) { // 获取点击的标题
            console.log('title:', title)
        },
        tq() {
            this.$router.push({ path: "/tq" })
        },
        sm() {
            this.$router.push({ path: "/sm" })
        },
        xy() {
            this.$router.push({ path: "/xy" })
        },
        wl() {
            console.log(1)
            this.$router.push({ path: "/wl" })
        },
        time() {
            this.$router.push({ path: "/time" })
        },
        zb() {
            let url = "live.jnccljh.com/ms/post579/msg-file29937e08479845e0c202419762c8630d.html"
            let path = window.location.protocol + "//" + url
            window.open(path, '_blank');
        },
        download() {
            this.$router.push({ path: "/Download" })
        },
        xyjj() {
            this.$router.push({ path: "/xyjj" })
        },
        jtjj() {
            this.$router.push({ path: "/jtjj" })
        },
        mejz() {
            this.$router.push({ path: "/mejz" })
        },
        sjxs() {
            this.$router.push({ path: "/sjxs" })
        },
        zdzt() {
            this.$router.push({ path: "/zdzt" })
        },
        zmzt() {
            this.$router.push({ path: "/zmzt" })
        },
        zlxz() {
            this.$router.push({ path: "/zlxz" })
        },
        jzzt() {
            this.$router.push({ path: "/jzzt" })
        },
        tqjj() {
            this.$router.push({ path: "/tqjj" })
        },
        sgjj() {
            this.$router.push({ path: "/sgjj" })
        },
        //将移动的关键代码移出
        moveMarquee() {
            // 获取内容区宽度
            var width1 = (document.getElementById('marquee1').getBoundingClientRect().width)
            var width2 = (document.getElementById('marquee2').getBoundingClientRect().width)
            //width为第二个span标签尾部到盒子尾部的距离，500为外层盒子的宽度
            var width = width1 + width2 - 500
            var marquee1 = document.getElementById("marquee1");
            var marquee2 = document.getElementById("marquee2");
            this.speed1 = this.speed1 - 1;
            this.speed2 -= 1;
            // 如果speed2的尾部移到盒子的尾部并且speed1的移动距离不超过文字的距离
            if (-this.speed2 >= width && -this.speed1 >= width1) {
                //让speed1重新在原位置移动
                this.speed1 = 500;
            }
            if (-this.speed2 >= width1 + width2) {
                //如果speed2的尾部移动到盒子的头部，让speed2跟在speed1之后移动
                this.speed2 = 0
            }
            marquee1.style.transform = "translateX(" + this.speed1 + "px)";
            marquee2.style.transform = "translateX(" + this.speed2 + "px)";
        },
        runMarquee() {
            var marquee1 = document.getElementById("marquee1");
            var marquee2 = document.getElementById("marquee2");
            this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
            //监听鼠标移入，清空定时器
            marquee1.addEventListener('mouseenter', () => {
                clearInterval(this.marqueeVar);
                this.marqueeVar = null
            })
            marquee2.addEventListener('mouseenter', () => {
                clearInterval(this.marqueeVar);
                this.marqueeVar = null
            })
            //监听鼠标移开，重启定时器
            marquee1.addEventListener('mouseleave', () => {
                this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
            }
            )
            marquee2.addEventListener('mouseleave', () => {
                this.marqueeVar = setInterval(() => this.moveMarquee(), 30);
            }
            )
        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
    position: relative;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.notice {
    width: 100%;
    height: 33px;
    background-color: #1463FF;
    display: flex;
    align-items: center;
}

.notice_center {
    margin-left: 15%;
    display: flex;
    align-items: center;
}

.dibu2 {
    width: 950px;
    /* font-size: 0.25rem; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    line-height: 14px;
    text-align: left;
    font-style: normal;
}

#marquee1 {
    display: inline-block;
}

#marquee2 {
    display: inline-block;
}

.information {
    margin-left: 10px;
}

.four {
    height: 360px;
    width: 70%;
    margin: 0 auto;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    position: relative;
    font-family: PingFangSC, PingFang SC;
}

.wl {
    position: absolute;
    z-index: 999;
    width: 24%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    /* background-image: url(../image/wl.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    flex-direction: column;
    color: #FFDAB4;

}

.wl:hover img {
    display: none;
}
.bh:hover{
    border-radius: 5px;
  background-color: rgba(91, 155, 213, 0.2);
}
.xy {
    position: absolute;
    z-index: 999;
    left: 25%;
    width: 24%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    /* background-image: url(../image/xy.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    flex-direction: column;
    color: #FFDAB4;
}

.xy:hover img {
    display: none;
}

.sm {
    position: absolute;
    z-index: 999;
    left: 49.8%;
    width: 24%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    /* background-image: url(../image/sm.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    flex-direction: column;
    color: #FFDAB4;
}

.sm:hover img {
    display: none;
}

.tq {
    position: absolute;
    z-index: 999;
    left: 75%;
    width: 24%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    /* background-image: url(../image/tq.png);
    background-size: 100% 100%;
    background-repeat: no-repeat; */
    flex-direction: column;
    color: #FFDAB4;
}

.tq:hover img {
    display: none;
}

.wlcb {
    font-family: PingFangSC, PingFang SC;
    position: absolute;
    z-index: 3;
    width: 24%;
    height: 300px;
    background-image: url(../image/qljx.png);
    background-size: 100% 100%;
    color: #FFDAB4;
    margin-right: 1.5%;

}

.wlcba {
    /* display: none; */
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 300px;
    z-index: 999;
}

.xyzm {
    font-family: PingFangSC, PingFang SC;
    position: absolute;
    left: 25%;
    z-index: 3;
    width: 24%;
    height: 300px;
    background-image: url(../image/jx.png);
    background-size: 100% 100%;
    color: #FFDAB4;
    margin-right: 1.5%;
}

.xyzma {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 300px;
    z-index: 999;
}

.smzl {
    font-family: PingFangSC, PingFang SC;
    position: absolute;
    z-index: 888;
    left: 49.8%;
    width: 24%;
    height: 300px;
    background-image: url(../image/smjx.png);
    background-size: 100% 100%;
    color: #FFDAB4;
    margin-right: 1.5%;
}

.smzla {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 300px;
    z-index: 999;
}

.tqzj {
    font-family: PingFangSC, PingFang SC;
    position: absolute;
    z-index: 888;
    left: 75%;
    width: 24%;
    height: 300px;
    background-image: url(../image/tqjx.png);
    background-size: 100% 100%;
    color: #FFDAB4;
    margin-right: 1.5%;
}
.tqzja {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 300px;
    z-index: 999;
}

.wlcb_top {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

}

.xyzm_top {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

}

.smzl_top {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}

.tqzj_top {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}

.wlcb_bottom {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 180px;
    margin: 0 auto;
    margin-top: 40px;
}

.xyzm_bottom {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 180px;
    margin: 0 auto;
    margin-top: 40px;
}

.smzl_bottom {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 180px;
    margin: 0 auto;
    margin-top: 40px;
}

.tqzj_bottom {
    font-family: PingFangSC, PingFang SC;
    width: 80%;
    height: 180px;
    margin: 0 auto;
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue